import { gameConfig } from '@/config/game.config';
import { aNumbersFor, type Blockers } from './combos';
import type { LevelDef } from '@/config/levels.config';
import type { ModeDef } from '@/config/modes.config';
import type { GenParams } from './types';
import type { SessionRules } from './session';

/** Bridge from app config to engine params for one mode + level at a given B cap and blocker lines. */
export function rulesFor(
  mode: ModeDef,
  level: LevelDef,
  bMax: number,
  blockers: Blockers,
): SessionRules {
  const gen: GenParams = {
    a: aNumbersFor(blockers),
    blockers,
    bMin: mode.b.min,
    bMax: Math.min(bMax, mode.b.max),
    bSumMax: mode.bSumMax,
    terms: level.terms,
    stripes: mode.region === 'stripe',
    operators: level.terms > 1 ? ['+', '-'] : ['+'],
    options: gameConfig.options,
    resultMin: 1,
  };
  return { gen, scoring: { base: gameConfig.base, streakBonus: gameConfig.streakBonus } };
}
